import React from "react";
import { StatementPeriod } from "swan-public-api-client";
import { FormattedMessage } from "react-intl";

interface Props {
  value: StatementPeriod
}

export function FormattedStatementPeriod(props: Props) {
  switch (props.value) {
    case StatementPeriod.Daily:
      return (<FormattedMessage id="statementPeriod.daily" />);
    case StatementPeriod.Monthly:
      return (<FormattedMessage id="statementPeriod.monthly" />);
    default:
      throw new Error(`Unknown StatementPeriod "${props.value}"`);
  }
}
